import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
root: {
    marginTop: 50,
    alignContent: "space-between"
}
});